export default {"src":"/_next/static/media/icon-eye-opened.06303108.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};